
import { container } from '@eureka/services';
import { Toast } from 'patsnap-biz';
import _ from 'lodash';
import { updateTokenBaseRequestHeaders } from '@eureka/startup/src/enable-token-base';
import { getCurrentLanguage } from '@eureka/language-tool'

updateTokenBaseRequestHeaders({ 'X-Site-Lang': getCurrentLanguage()?.toString().toUpperCase() })

/**
 * 全局HTTP错误码提示
 */
export const registerHttpErrorTooltip = (i18n:any) => {
    container.ErrorHandlerService.start()

    container.RnDHttp.setErrorDisplay((data) => {
        const errorCodeI18nKey = `commonStatusCode.${data.code}`;
        const defaultErrorCodeI18nKey = 'commonStatusCode.400';
        const message = i18n.te(errorCodeI18nKey) ? i18n.t(errorCodeI18nKey, _.get(data, 'params', {})) : i18n.t(defaultErrorCodeI18nKey);
        Toast({
            type: 'error',
            message,
            duration: 5000,
            showClose: true,
            dangerouslyUseHTMLString: true,
        })
    });
}
